import { createAction, props } from "@ngrx/store";
import { VoucherListFilterDto } from "src/app/shared/models/voucher/voucherListFilterDto";
import { VoucherWithResultDto } from "src/app/shared/models/voucher/voucherWithResultDto";

export const invokeVouchersForLocationPartner = createAction(
  "[ Invoke All vouchers for a specific location partner ] Invoke All vouchers for a specific location partner",
  props<{ filter: VoucherListFilterDto }>()
);
export const resultVouchersForLocationPartner = createAction(
  "[ Result All vouchers for a specific location partner ] Result All vouchers for a specific location partner",
  props<{ vouchers: VoucherWithResultDto | null }>()
);
